// Mock data para la Unión Industrial Quilmes

export const mockData = {
  contact: {
    email: 'uiquilmes867@gmail.com',
    phone: '7522-7496',
    phoneLink: '+541175227496',
    address: 'Alvear 867, Quilmes, Buenos Aires',
    coordinates: { lat: -34.7208, lng: -58.2541 }
  },

  benefits: [
    {
      id: 6,
      title: 'Habilitación Industrial',
      description: 'Gestión y representación de trámites ante la secretaría de Habilitaciones Industriales municipal.',
      icon: 'FileCheck'
    },
    {
      id: 3,
      title: 'Seguridad, Higiene y Medio Ambiente',
      description: 'Representación técnica profesional en higiene, seguridad y medio ambiente industrial.',
      icon: 'HardHat'
    },
    {
      id: 11,
      title: 'Asistencia Integral en Parques Industriales',
      description: 'Gestión y asesoramiento completo para radicación y operación en parques industriales.',
      icon: 'Factory'
    },
    {
      id: 1,
      title: 'Comercio Exterior',
      description: 'Asesoramiento en inscripción como importador/exportador, gestión de despachos aduaneros y documentación internacional.',
      icon: 'Globe'
    },
    {
      id: 13,
      title: 'Asistencia Integral en Servicios de Matafuegos',
      description: 'Recarga, mantenimiento y asesoramiento en sistemas de protección contra incendios.',
      icon: 'FireExtinguisher'
    },
    {
      id: 5,
      title: 'Seguros y Evaluación de Riesgos',
      description: 'Asesoramiento especializado en seguros industriales y evaluación integral de riesgos.',
      icon: 'ShieldCheck'
    },
    {
      id: 9,
      title: 'Arquitectura y Desarrollo',
      description: 'Servicios profesionales de arquitectura y desarrollo de proyectos industriales y comerciales.',
      icon: 'Building2'
    },
    {
      id: 2,
      title: 'Asistencia Legal',
      description: 'Consultas por mediaciones privadas y asesoramiento en ámbitos laboral, tributario, penal, civil y comercial.',
      icon: 'Scale'
    },
    {
      id: 10,
      title: 'Asistencia Contable',
      description: 'Asesoramiento contable integral, liquidación de impuestos y gestión administrativa para empresas.',
      icon: 'Calculator'
    },
    {
      id: 7,
      title: 'Servicios Financieros',
      description: 'Asesoramiento en inversiones y servicios financieros especializados para el sector industrial.',
      icon: 'Landmark'
    },
    {
      id: 4,
      title: 'Recursos Humanos',
      description: 'Servicios de reclutamiento, selección de personal, manuales de inducción y propuestas de beneficios.',
      icon: 'Users'
    },
    {
      id: 8,
      title: 'Traducción e Interpretación',
      description: 'Traducciones técnicas y comerciales especializadas en desarrollo industrial y textos corporativos.',
      icon: 'Languages'
    },
    {
      id: 12,
      title: 'Limpieza Integral',
      description: 'Servicios profesionales de limpieza y mantenimiento para instalaciones industriales.',
      icon: 'SprayCan'
    },
    {
      id: 14,
      title: 'Servicios de Catering',
      description: 'Soluciones de catering profesional para eventos corporativos y comedores industriales.',
      icon: 'UtensilsCrossed'
    }
  ],

  // upcomingEvents eliminado por solicitud del usuario

  testimonials: [
    {
      id: 1,
      author: 'Juan Martínez',
      company: 'Acropolis',
      text: 'La UIQ nos brindó el soporte necesario para modernizar nuestros procesos. Las capacitaciones fueron fundamentales para nuestro crecimiento.',
      logo: null
    },
    {
      id: 2,
      author: 'María Fernández',
      company: 'Cervecería y Maltería Quilmes',
      text: 'Gracias a la red de contactos de la UIQ, pudimos acceder a nuevos clientes y expandir nuestro mercado significativamente.',
      logo: null
    },
    {
      id: 3,
      author: 'Roberto Sánchez',
      company: 'Alimentos Santa Cruz',
      text: 'El asesoramiento técnico y legal que recibimos fue clave para resolver cuestiones regulatorias complejas. Muy recomendable.',
      logo: null
    }
  ],

  memberCompanies: [
    { 
      name: 'Kalop', 
      logo: '/img/kalop.webp',
      url: 'https://kalop.com.ar/'
    },
    { 
      name: 'Apres', 
      logo: '/img/apres.png',
      url: 'https://www.apressalud.com.ar/'
    },
    { 
      name: 'Cervecería y Maltería Quilmes', 
      logo: '/img/cerveceria.webp',
      url: 'https://www.cerveceriaymalteriaquilmes.com/'
    },
    { 
      name: 'Cresata', 
      logo: '/img/cresata.webp',
      url: 'http://www.cresata.com.ar/'
    },
    { 
      name: 'Carolina Diaz Seguros', 
      logo: '/img/carolina-diaz.png',
      url: 'https://www.instagram.com/gdgrupodiaz/'
    },
    { 
      name: 'Gora', 
      logo: '/img/gora.webp',
      url: 'https://gora.com.ar/'
    },
    { 
      name: 'Alimentos Santa Cruz', 
      logo: '/img/santa-cruz.png',
      url: 'https://alimentossantacruz.com/'
    },
    { 
      name: 'Sin Par', 
      logo: '/img/sin-par.jpg',
      url: 'https://sinpar.com.ar/'
    },
    { 
      name: 'Mistral', 
      logo: '/img/mistral.png',
      url: 'https://www.mistral.com.ar/'
    },
    { 
      name: 'Parque Industrial Unión Industrial Quilmes', 
      logo: '/img/pitq.png',
      url: 'https://pitq.com.ar/'
    },
    { 
      name: 'Consultora B2B de RRHH', 
      logo: '/img/active-rrhh.jpeg',
      url: 'https://activerrhh.com.ar'
    },
    { 
      name: 'Sanatorio Bernal', 
      logo: '/img/sanatorio-bernal.webp',
      url: 'https://sanatoriobernal.com.ar/'
    },
    { 
      name: 'Sancor Salud', 
      logo: '/img/sancor.png',
      url: 'https://planessancorsalud.com.ar/'
    },
    { 
      name: 'Omint', 
      logo: '/img/omint.webp',
      url: 'https://wa.me/message/JDK2XPAKHCVXB1'
    }
  ],

  howToJoin: [
    {
      step: 1,
      title: 'Contactanos',
      description: 'Comunicate por teléfono o email para expresar tu interés en asociarte.'
    },
    {
      step: 2,
      title: 'Reunión informativa',
      description: 'Coordinamos una reunión para conocer tu empresa y explicarte todos los beneficios en detalle.'
    },
    {
      step: 3,
      title: 'Formalización',
      description: 'Completamos la documentación necesaria y comenzás a disfrutar de todos los beneficios de ser socio UIQ.'
    }
  ],

  aboutUIQ: {
    description: 'La Unión Industrial Quilmes (UIQ) es una asociación sin fines de lucro que nuclea a empresas industriales de Quilmes y la zona sur del Gran Buenos Aires. Desde hace más de 50 años, trabajamos para fortalecer el sector industrial mediante servicios de asistencia, capacitación y representación institucional.',
    mission: 'Promover el desarrollo sustentable de la industria local, brindando herramientas y servicios que potencien la competitividad de nuestras empresas asociadas.',
    vision: 'Ser la entidad de referencia para el sector industrial de Quilmes, impulsando la innovación, el crecimiento y la integración empresarial.'
  },

  socialMedia: {
    facebook: '#',
    instagram: '#',
    linkedin: '#',
    twitter: '#'
  }
};
